let mapInstances = $('.google-map-instance');

if(mapInstances.length) {
  mapInstances.each(function() {
    let mapElement = $(this);
    let lat = parseFloat(mapElement.data('latitude'));
    let lng = parseFloat(mapElement.data('longitude'));
    let zoom = parseInt(mapElement.data('zoom')) || 14;
    let mapType = mapElement.data('map-type') || 'roadmap';

    console.log(lat, lng, zoom, mapType);

    let mapOptions = {
      center: { lat: lat, lng: lng },
      zoom: zoom,
        // mapTypeControl: false,
        // disableDefaultUI: true,
      // mapTypeId: google.maps.MapTypeId[mapType.toUpperCase()]
    };

    let mapInstance = new google.maps.Map(mapElement[0], mapOptions);

    let marker1 = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: mapInstance
    });

      google.maps.event.addListener(marker1, 'click', function(event) {
          console.log('Marker clicked');
          event.stopPropagation();
          // Your custom marker click logic
      });
  });
}
